const FeesContentThree = () => {
  const securityFeatures = [
    {
      title: "Currencies (Forex)",
      text: "Trade major, minor, and exotic currency pairs with institutional-grade spreads starting from 0.8 pips and zero hidden fees. Our fast execution and transparent pricing minimize friction for scalpers, swing traders, and hedgers alike.",
    },
    {
      title: "Commodities",
      text: "Trade gold, silver, oil, and natural gas with ultra-tight spreads, flexible contract sizes, and low-cost exposure. With competitive overnight rates and real-time pricing, you always know exactly what you’re paying.",
    },
    {
      title: "Stocks",
      text: "Access global equities from the US, Europe, and Asia with low spreads starting from 0.05 USD and zero commission on popular CFDs. Enjoy fractional trading, fast order fills, and rich market data for smarter decision-making.",
    },
    {
      title: "Indices",
      text: "Trade leading global indices like the S&P 500, NASDAQ, FTSE, and DAX with tight spreads from 1.0 point and no commission. Benefit from smooth execution and 24/5 access, ideal for both short-term and long-term strategies.",
    },
    {
      title: "Cryptocurrencies",
      text: "Access major cryptocurrencies with competitive spreads from 0.8% and swap-free, 24/7 trading. Enjoy secure infrastructure, fast execution, and transparent pricing for seamless digital asset trading.",
    },
  ];

  return (
    <div className="sm-security-section">
      <div className="container">
        <div className="row">
          {/* LEFT SIDE: Main Heading */}
          <div className="col-lg-4 col-md-12 col-12">
            <div className="sm-content-left">
              <h2 className="sm-main-title">
                Commissions & Spreads That Work for Every Trader
              </h2>
            </div>
          </div>

          {/* RIGHT SIDE: Intro Text + Feature List */}
          <div className="col-lg-8 col-md-12 col-12">
            <div className="sm-content-right">
              <p className="sm-intro-text">
                Transparent pricing across all major asset classes, built to
                give you tighter spreads, lower costs, and full control of your
                trading strategy.
              </p>

              <div className="sm-feature-list">
                {securityFeatures.map((item, index) => (
                  <div key={index} className="sm-feature-item">
                    <div className="sm-feature-row">
                      <div className="sm-feature-title">
                        <h3>{item.title}</h3>
                      </div>
                      <div className="sm-feature-desc">
                        <p>{item.text}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeesContentThree;
